import * as React from "react";

function SvgIcons8ClockAdd(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M16 4C9.385 4 4 9.385 4 16s5.385 12 12 12c.357 0 .71-.018 1.059-.049C18.44 30.362 21.036 32 24 32c4.4 0 8-3.6 8-8 0-2.964-1.638-5.56-4.049-6.941.03-.35.049-.702.049-1.059 0-6.615-5.385-12-12-12zm0 2c5.535 0 10 4.465 10 10 0 .088-.01.174-.012.262A7.925 7.925 0 0024 16c-4.4 0-8 3.6-8 8 0 .687.097 1.351.262 1.988-.088.003-.174.012-.262.012-5.535 0-10-4.465-10-10S10.465 6 16 6zm-1 2v7h-5v2h7V8h-2zm9 10c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zm-1 2v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8ClockAdd);
